import { ref, computed } from 'vue';
import fiakApi from '../../../api/fiak-api';
const branches = ref(null);
const selectedBranch = ref(null);
const addressRef = ref(null);
export const useBranches = () => {
	const technicalError = ref(false);
	const selectBranch = (id) => {
		selectedBranch.value = branches.value.find((branch) => branch.branchCode == id);
	};
	const getSelectedBranch = () => selectedBranch;
	const addressText = computed(() =>
		selectedBranch.value ? `${selectedBranch.value.zipCode} ${selectedBranch.value.town} ${selectedBranch.value.address}`.trim() : ''
	);
	const branchCode = computed(() => selectedBranch.value.branchCode);
	const isOpen = (id, index) => {
		return !!branches.value.find((branch) => branch.branchCode == id).openingHours[index];
	};
	const getBranches = async ({ lat, lng, address }) => {
		try {
			const { data } = await fiakApi.search({ lat, lng, address });
			branches.value = data;
		} catch (err) {
			technicalError.value = true;
		}
	};

	return {
		branches,
		addressRef,
		branchCode,
		addressText,
		selectedBranch,
		getBranches,
		getSelectedBranch,
		selectBranch,
		isOpen
	};
};
